import React, { useEffect } from 'react';
import { Button, Drawer, Form, Input, message, Select } from 'antd';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { KATOService } from 'services/KATOService';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

const status = [
  {
    text: 'Не активный',
    value: 0,
  },
  {
    text: 'Активный',
    value: 1,
  },
];

function KATOForm({ isActive, onClose, onSuccess, initialValues, parentList }) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { code, name_kaz, name_rus, status, parent } = initialValues;

      form.setFieldsValue({
        parent_id: parent?.id,
        code,
        name_kaz,
        name_rus,
        status,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      id: initialValues?.id,
    };

    if (isEditing) {
      handleUpdate(payload, initialValues?.id);
    } else {
      handleCreate(values);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isCreated = await KATOService.createKATO(data);

      if (isCreated) {
        handleConfirm();
        message.success(SUCCESS_CREATE);
      }
    } catch (err) {
      message.error(CREATE_ERROR);
    } finally {
      hide();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await KATOService.updateKATO(data, id);

      if (isUpdated) {
        handleConfirm();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  const handleConfirm = () => {
    onClose();
    onSuccess();
    form.resetFields();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование KATO' : 'Создание KATO'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="parent_id" label="Наименование области или города">
          <Select
            allowClear
            showSearch
            placeholder="Область или город"
            optionFilterProp="children"
          >
            {parentList.map(({ id, name_rus }) => (
              <Select.Option key={id} value={id}>
                {name_rus}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="code" label="Код" rules={[requiredRule]}>
          <Input placeholder="Код" allowClear />
        </Form.Item>

        <Form.Item
          name="name_kaz"
          label="Наименование на казахском"
          rules={[requiredRule]}
        >
          <Input
            placeholder="Наименование области или города на казахском"
            allowClear
          />
        </Form.Item>

        <Form.Item
          name="name_rus"
          label="Наименование на русском"
          rules={[requiredRule]}
        >
          <Input
            placeholder="Наименование области или города на русском"
            allowClear
          />
        </Form.Item>

        <Form.Item name="status" label="Статус" rules={[requiredRule]}>
          <Select placeholder="Статус" allowClear>
            {status.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { KATOForm };
